module.exports = __webpack_public_path__ + "img/people.ec9eeed1.png";